import { createRouter, createWebHistory } from 'vue-router'; // Vue Router v4
import Home from './views/Home';
import PermitDetail from './views/foreigner/[pid]';
import Login from './views/Login';
import PassRecoverySecond from './views/PassRecoverySecond';
import PrivacyPolicy from './views/PrivacyPolicy';
import InternalUsers from '@/views/admin/cms/Internal/Users';
import ClientsUsers from '@/views/admin/cms/Clients/Users';
import ClientsCompanies from '@/views/admin/cms/Clients/Companies';
import PermitDocuments from '@/views/admin/cms/PermitManagement/Documents';
import PermitStatuses from '@/views/admin/cms/PermitManagement/Statuses';
import PermitActionDates from '@/views/admin/cms/PermitManagement/ActionDates';
import PermitTypes from '@/views/admin/cms/PermitManagement/PermitTypes';
import InternalPlaces from '@/views/admin/cms/Internal/Places';
import AuditLog from '@/views/admin/cms/Log/AuditLog';
import AgencyCompanies from '@/views/admin/cms/Agency/Companies';
import AgencyUsers from '@/views/admin/cms/Agency/Users';
import ViewForeigners from '@/views/admin/foreigners/Foreigners';
import ViewForeigner from './views/admin/foreigners/Foreigner';
import ProfileSettings from './views/ProfileSettings';
import ViewNotifications from './views/admin/Notifications';
import ResetLinkExpired from './views/ResetLinkExpired';
import ResetLinkAutorefresh from './views/ResetLinkAutorefresh';
import MobileLandingPage from './views/MobileLandingPage';
import FAQs from './views/FAQs';
import InternalFaq from '@/views/admin/cms/Internal/Faq';
import FaqNewOrEdit from '@/views/admin/cms/Internal/FaqNewOrEdit';
import Dashboard from '@/views/admin/dashboard/Dashboard';
import Messaging from './views/foreigner/Messaging';

import UIKit from './views/UIKit';
import store from './vuex/store';
import axios from 'axios';
import baseURL from './services/APIConfig';

import QuestionnairePage from './views/QuestionnairePage.vue';
// Create the router instance
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL), // Use Web History API
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true,
        requiresAdminRole: true,
      },
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
      meta: {
        requiresAuth: false,
      },
    },
    // Auth
    {
      path: '/reset_password/expired_link',
      name: 'linkExpired',
      component: ResetLinkExpired,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/reset_password/autorefresh_link',
      name: 'linkExpiredAutorefresh',
      component: ResetLinkAutorefresh,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/mobile',
      name: 'mobile',
      component: MobileLandingPage,
    },
    {
      path: '/reset_password/confirm/:uid',
      name: 'PassRecoverySecond',
      component: PassRecoverySecond,
    },
    // Admin -- Internal
    {
      path: '/administration/internal/users',
      name: 'internalUsers',
      component: InternalUsers,
      meta: {
        requiresAuth: true,
        requiresAdminRole: true,
      },
    },
    {
      path: '/administration/internal/places',
      name: 'internalPlaces',
      component: InternalPlaces,
      meta: {
        requiresAuth: true,
        requiresAdminRole: true,
      },
    },
    {
      path: '/administration/internal/faq/new',
      name: 'internalFaqNew',
      component: FaqNewOrEdit,
      meta: {
        requiresAuth: true,
        requiresAdminRole: true,
      },
    },
    {
      path: '/administration/internal/faq/:id',
      name: 'internalFaqEdit',
      component: FaqNewOrEdit,
      meta: {
        requiresAuth: true,
        requiresAdminRole: true,
      },
    },
    {
      path: '/administration/internal/faq',
      name: 'internalFaq',
      component: InternalFaq,
      meta: {
        requiresAuth: true,
        requiresAdminRole: true,
      },
    },
    // Admin -- Clients
    {
      path: '/administration/clients/users',
      name: 'clientsUsers',
      component: ClientsUsers,
      meta: {
        requiresAuth: true,
        requiresAdminRole: true,
      },
    },
    {
      path: '/administration/clients/companies',
      name: 'clientsCompanies',
      component: ClientsCompanies,
      meta: {
        requiresAuth: true,
        requiresAdminRole: true,
      },
    },
    // Admin -- Permit
    {
      path: '/administration/permit/documents',
      name: 'permitDocuments',
      component: PermitDocuments,
      meta: {
        requiresAuth: true,
        requiresAdminRole: true,
      },
    },
    {
      path: '/administration/permit/statuses',
      name: 'permitStatuses',
      component: PermitStatuses,
      meta: {
        requiresAuth: true,
        requiresAdminRole: true,
      },
    },
    {
      path: '/administration/permit/action_dates',
      name: 'permitActionDates',
      component: PermitActionDates,
      meta: {
        requiresAuth: true,
        requiresAdminRole: true,
      },
    },
    {
      path: '/administration/permit/types',
      name: 'permitTypes',
      component: PermitTypes,
      meta: {
        requiresAuth: true,
        requiresAdminRole: true,
      },
    },
    // Admin -- Agency
    {
      path: '/administration/agency/companies',
      name: 'agencyCompanies',
      component: AgencyCompanies,
      meta: {
        requiresAuth: true,
        requiresAdminRole: true,
      },
    },
    {
      path: '/administration/agency/users',
      name: 'agencyUser',
      component: AgencyUsers,
      meta: {
        requiresAuth: true,
        requiresAdminRole: true,
      },
    },
    // Admin -- Audit
    {
      path: '/administration/audit_log',
      name: 'auditLog',
      component: AuditLog,
      meta: {
        requiresAuth: true,
        requiresAdminRole: true,
      },
    },
    // Foreigners
    {
      path: '/foreigners',
      name: 'foreigners',
      component: ViewForeigners,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigners/:fid/info/notifications',
      props: true,
      name: 'foreignersInfoNotif',
      component: ViewForeigner,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigners/:fid/info',
      props: true,
      name: 'foreignersInfo',
      component: ViewForeigner,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigners/:fid/messaging',
      props: true,
      name: 'foreignersMessaging',
      component: ViewForeigner,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigners/:fid/messaging/:pid',
      props: true,
      name: 'foreignersMessagingPID',
      component: ViewForeigner,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigners/:fid/messaging/:pid/:mid',
      props: true,
      name: 'foreignersMessagingMID',
      component: ViewForeigner,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/messaging',
      props: true,
      name: 'foreignerViewMessaging',
      component: Messaging,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/messaging/:pid',
      props: true,
      name: 'foreignerViewMessagingPID',
      component: Messaging,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/messaging/:pid/:mid',
      props: true,
      name: 'foreignerViewMessagingMID',
      component: Messaging,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigners/:fid/questionnaires',
      props: true,
      name: 'foreignersQs',
      component: ViewForeigner,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigners/:fid/permits',
      props: true,
      name: 'foreignersPermit',
      component: ViewForeigner,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigners/:fid/logs',
      props: true,
      name: 'foreignersLogs',
      component: ViewForeigner,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigners/:fid/permits/:pid',
      props: true,
      name: 'foreignersPermitDetail',
      component: ViewForeigner,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigners/:fid/permits/:pid/status',
      props: true,
      name: 'foreignersDocuments',
      component: ViewForeigner,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigners/:fid/permits/:pid/documents',
      props: true,
      name: 'foreignersDocuments',
      component: ViewForeigner,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigners/:fid',
      props: true,
      name: 'foreignersId',
      component: ViewForeigner,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigners/:fid/questionnaires/:qid',
      props: true,
      name: 'AdminForeignersQuestionnaire',
      component: QuestionnairePage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigners/questionnaires/:qid',
      props: true,
      name: 'ForeignerForeignersQuestionnaire',
      component: QuestionnairePage,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/family/:fid/messaging',
      props: true,
      name: 'FamilyMessaging',
      component: Messaging,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/family/:fid/messaging/:pid',
      props: true,
      name: 'FamilyMessagingPID',
      component: Messaging,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/family/:fid/messaging/:pid/:mid',
      props: true,
      name: 'FamilyMessagingMID',
      component: Messaging,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/questionnaires',
      props: true,
      name: 'dashboardfffff',
      component: Home,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/me',
      name: 'usersMe',
      component: ProfileSettings,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: ViewNotifications,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigner/:fid',
      props: true,
      name: 'dashboardForeigner',
      component: Home,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigner/:fid/permits/:pid/documents',
      props: true,
      name: 'permitDetailDocuments',
      component: PermitDetail,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/foreigner/:fid/permits/:pid',
      props: true,
      name: 'permitDetail',
      component: PermitDetail,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/permits/:pid/documents', // TODO: remove when backend will update to the URLs above notification link
      props: true,
      name: 'permitDetailDocuments',
      component: PermitDetail,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/permits/:pid', // TODO: remove when backend will update to the URLs above notification link
      props: true,
      name: 'permitDetail',
      component: PermitDetail,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/faq',
      name: 'faq',
      component: FAQs,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/ui-kit',
      name: 'ui-kit',
      component: UIKit,
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: '/:pathMatch(.*)*', // Catch-all route (not found)
      name: 'not-found',
      component: Home,
    },
  ],
});

// Add router guards
router.beforeEach(async(to, from, next) => {
  // Handle custom logic for localStorage redirects and guards

  const loggedIn = localStorage.getItem('token');
  if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
    next({ name: 'login' });
  } else if (to.matched.some((record) => record.meta.requiresAdminRole)) {
    // Handle admin-only routes
    let isAdmin;

    if (!store.state.v2?.shared?.profile?.me?.role) {
      // Fetch user's role by API if not already in the state
      try {
        const token = window.localStorage.getItem('token');
        const { data } = await axios.get(`${baseURL}/user/me/`, {
          headers: {
            Authorization: `JWT ${token}`,
          },
        });

        isAdmin = data?.data?.role === 0 || data?.data?.role === 10;
      } catch (error) {
        isAdmin = false;
      }
    } else {
      isAdmin = store.state.v2.shared.profile.me.role === 0 || store.state.v2.shared.profile.me.role === 10;
    }

    if (!isAdmin) {
      next({ path: '/' });
    } else {
      next(); // Proceed to the route
    }
  } else {
    next(); // No authentication or admin role required
  }
});

export default router;
